import React from 'react'
import { TabSelectWrap, UserTypeTabSelect, TabItem, CheckWrapper } from '../../pages/auth/auth.styled'

import { FiUser } from "react-icons/fi";
import { PiChurchLight } from "react-icons/pi";
import { FaCheck } from "react-icons/fa";
import { useSelector, useDispatch } from 'react-redux'
import { setUserType } from '../../features/auth/authSlice'
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';



export default function SelectUserType({ userTooltip, churchTooltip }) {

    const { t } = useTranslation('auth')

    const dispatch = useDispatch()
    const { userType } = useSelector((state) => state.auth)
  
    const handleUserType = (value) => { 
        dispatch(setUserType(value))
    }
 
    return (
        <TabSelectWrap>
            <UserTypeTabSelect>
                <Tooltip title={userTooltip} placement='top' >
                    <TabItem
                        side={'left'} 
                        onClick={() => handleUserType('user')}
                        selected={userType === 'user' ? (true):(false)}
                        >
                        <FiUser size={24}  />
                        <span>{t('accountType.member')}</span>
                        {
                            userType === 'user' && (
                                <CheckWrapper>
                                    <FaCheck  />
                                </CheckWrapper>
                            )
                        }
                    </TabItem>
                </Tooltip>
                <Tooltip title={churchTooltip} placement='top'> 
                <TabItem
                    side={'right'}
                    onClick={() => handleUserType('church')} 
                    selected={userType === 'church' ? (true):(false)}
                    >
                    <PiChurchLight size={24} />
                    <span>{t('accountType.church')}</span>

                    {
                        userType === 'church' && (
                            <CheckWrapper>
                                <FaCheck  />
                            </CheckWrapper>
                        )
                    }
                </TabItem>
                </Tooltip>
            </UserTypeTabSelect>
        </TabSelectWrap>
    )
}
